var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261156517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9998 20.0006C16.418 20.0006 19.9997 16.419 19.9997 12.0008C19.9997 7.58262 16.418 4.00098 11.9998 4.00098C7.58165 4.00098 4 7.58262 4 12.0008C4 16.419 7.58165 20.0006 11.9998 20.0006Z",
    fill: "#7F43FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 23.9977C5.38309 23.9977 0 18.6146 0 11.9979C0 5.38114 5.38309 -0.00195312 12 -0.00195312C18.6169 -0.00195312 24 5.38114 24 11.9979C24 18.6146 18.6169 23.9977 12 23.9977ZM12 1.91137C6.43816 1.91137 1.91332 6.43621 1.91332 11.9979C1.91332 17.5596 6.43816 22.0844 12 22.0844C17.5618 22.0844 22.0867 17.5596 22.0867 11.9979C22.0867 6.43621 17.5618 1.91137 12 1.91137Z",
    fill: "#7F43FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioSelected);
export default __webpack_public_path__ + "static/media/radio_selected.73d3782f7cb0b748ae59919d73be5453.svg";
export { ForwardRef as ReactComponent };